import React from 'react';
import PropTypes from 'prop-types';

const PickleballRangeScale = ({ 'data-testid': dataTestId }) => {
  const UTRNumbersPickleBall = [
    'P1',
    'P2',
    'P3',
    'P4',
    'P5',
    'P6',
    'P7',
    'P8',
    'P9',
    'P10',
  ];

  return (

      <div className="range-scale range-scale-pickleball" data-testid={dataTestId}>
          {UTRNumbersPickleBall.map((number) => (
              <div className={number} key={`utr-number-${number}`}>
                  {number}
              </div>
          ))}
          <div
              style={{
                border: '0.7px solid #A7B2C1',
                position: 'absolute',
                width: '100px',
                left: '42%',
                marginTop: '7px',
              }}
          />
          <div
              style={{
                border: '0.7px solid #A7B2C1',
                width: '100px',
                position: 'absolute',
                left: '71%',
                marginTop: '7px',
              }}
          />
      </div>
  );
};

PickleballRangeScale.propTypes = {
    'data-testid': PropTypes.string,
};

PickleballRangeScale.defaultProps = {
    'data-testid': undefined,
};

export default PickleballRangeScale;
